<template>
	<div class="call-info-cls">
		<section class="title-cls">来电信息</section>
		<section class="cell">
			<div class="left">
				<span>来电号码:</span>
				<span>{{isShowPhone ? callInfo.phoneNumber : hiddenPhone(callInfo.phoneNumber)}}({{callInfo.belong}})</span>
			</div>
			<div class="rigth">
				<span>热线号码:</span>
				<span>{{callInfo.calledNumber}}</span>
			</div>
		</section>
		<section class="cell" v-if="callInfo.ibStatus">
			<div class="left">
				<span>通话状态:</span>
				<span>{{callInfo.ibStatus === '1' ? '已接' : callInfo.ibStatus === '2' ? '未接' : ''}}</span>
			</div>
			<div class="rigth">
				<span>接听坐席:</span>
				<span>{{callInfo.userName}}</span>
			</div>
		</section>
		<section class="cell" v-if="callInfo.ibStatus">
			<div class="left">
				<span>来电时间:</span>
				<span>{{callInfo.callTime}}</span>
			</div>
			<div class="rigth">
				<span>结束时间:</span>
				<span>{{callInfo.endTime}}</span>
			</div>
		</section>
		<section class="cell" v-if="callInfo.ibStatus">
			<div class="left">
				<span>技能组:</span>
				<span>{{callInfo.skill}}</span>
			</div>
			<div class="rigth">
				<span>通话时长:</span>
				<span v-if="StoreIsAnswer && callInfo.iaId == StoreIsCallCurrentInfo.incidentId">{{StoreCallTime}}</span>
				<span v-else>{{callInfo.callDuration}}</span>
			</div>
		</section>
	</div>
</template>



<script>
import { mapGetters } from 'vuex';
export default {
	props: ['histId'],
	computed: {
		...mapGetters([
			'StoreCallTime',
			'StoreIsAnswer',
			'StoreIsCall',
			'StoreIsIdle',
			'StoreIsCallCurrentInfo',
			'isShowPhone'
		])
	},
	data() {
		return {
			callInfo: {}
		}
	},
	watch: {
		histId: {
			handler: function(val) {
				if(val) {
					this.getInfo();
				}
			},
			immediate: true,
			deep: true
		},
		StoreIsCall: {
			handler: function(val) {
				// if(val) {
					if(this.StoreIsIdle) {
						setTimeout(() => {
							this.getInfo();
						}, 500);
					}
				// }
			},
			immediate: true,
			deep: true
		},
		StoreIsAnswer: {
			handler: function(val) {
				if(this.StoreIsIdle) {
					setTimeout(() => {
						this.getInfo();
					}, 500);
				}
			},
			immediate: true,
			deep: true
		},
	},
	methods: {
		getInfo() {
			this.$api.apiPostCallIbContact(this.histId).then(response => {
				if(response.errcode != 0) return;
				this.callInfo = response.data;
			});
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
	}
}
</script>

<style lang="scss" scoped>
.call-info-cls {
	width: 100%;
	margin-bottom: 20px;
	padding: 0 10px;
	box-sizing: border-box;

	& > .title-cls {
		width: 100%;
		line-height: 46px;
		font-weight: bold;
		
		font-size: 14px;
		color: #3C4353;
		font-weight: bold;
		vertical-align: top;
		user-select:none;
	}

	& > .cell {
		width: 100%;
		height: 30px;
		line-height: 30px;

		& > div {
			width: 50%;
			display: inline-block;
			font-size: 12px;
			
			font-weight: 400;
			color: #3C4353;
			line-height: 22px;

			& > span:nth-of-type(1) {
				display: inline-block;
				width: 60px;
			}
		}
	}
}
</style>